<template>
  <div id="page-product-form">
    <vs-row>
      <vs-col>
        <card-page card-title="Ancestors">
          <vue-element-loading :active="busy"></vue-element-loading>
          <div :class="[
                'form-wrapper',
                showForm ? '' : 'empty-wrapper'
              ]"
          >
            <div class="flex justify-center m-4" v-if="!showForm">
              <p>No Ancestors have been added</p>
            </div>
            <vue-form-generator
                v-else
                class="mt-4 readonly-form facilities crud-additive-form bordered-buttons"
                ref="formAncestors"
                :model="value"
                :options="formOptions"
                :schema="schema"
            />
            <div :class="[
                'flex add-button-wrapper',
                showForm ? 'justify-end' : 'justify-center'
              ]"
            >
              <vs-button
                  class="mx-4 mb-4"
                  v-if="true || componentAccess.canCreate.access"
                  @click="goToCreate"
              >
                Add
              </vs-button>
            </div>
          </div>
        </card-page>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>

import FormModelMixin from '@/components/mixins/FormModelMixin';
import { selectOptions, arrayOptions } from '@/components/form/FormElementOption';
import CardPage from '../../../../components/Views/CardPage';
import CanAccessMixin from '@/components/mixins/CanAccessMixin';

export default {
  name: 'SectionAncestorsAdditiveForm',
  props: {
    value: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    loading: {
      type: Boolean,
      required: false,
      default: false,
    }
  },
  components: {
    CardPage,
  },
  mixins: [FormModelMixin, CanAccessMixin],
  data() {
    return {
      componentAccess: {
        canDelete: {
          route: 'facilities.sections.ancestors.delete',
          access: false,
        },
        canCreate: {
          route: 'facilities.sections.ancestors.create',
          access: false,
        },
      },
      model: {
        ancestors: [],
      },
      schema: {
        groups: [
          {
            styleClasses: 'text-black w-full',
            fields: [
              {
                model: 'ancestors',
                ...arrayOptions,
                hideAddButton: true,
                showRemoveButton: false,
                items: {
                  type: 'object',
                  schema: {
                    groups: [
                      {
                        styleClasses: 'w-11/12 flex justify-between items-center',
                        fields: [
                          {
                            disabled: true,
                            type: 'vueMultiSelect',
                            inputType: 'text',
                            styleClasses: 'w-4/12 flex flex-col justify-center',
                            label: 'Facility',
                            model: 'Facility_FK',
                            default: null,
                            values: () => this.facilities,
                            onChanged: async (model) => {
                              // Reset Section
                              delete model.SectionParent_FK;

                              // We just merge them into a big array so all of them can use it
                              this.sections = [
                                ...this.sections,
                                ...await this.getSectionOptions(model.Facility_FK.id)
                              ]
                            },
                            selectOptions,
                          },
                          {
                            disabled: true,
                            type: 'vueMultiSelect',
                            inputType: 'text',
                            styleClasses: 'w-3/12 flex flex-col justify-center',
                            label: 'Section',
                            model: 'SectionParent_FK',
                            // If there is no Facility_FK set, show nothing
                            // Otherwise find the sections that have that FK set.
                            values: (model) => this.sections.filter(({Facility_FK}) =>
                                !model.Facility_FK ? false : model.Facility_FK.id === Facility_FK),
                            selectOptions,
                          },
                          {
                            visible: ({SectionParent_FK}) => !SectionParent_FK,
                            type: 'label',
                            styleClasses: 'w-4/12 flex flex-col justify-center',
                          },
                          {
                            visible: ({SectionParent_FK}) => SectionParent_FK,
                            type: 'button',
                            styleClasses: 'w-3/12 my-0 flex',
                            fieldClasses: 'self-center',
                            buttonText: 'View Section',
                            onClick: async (model, schema) => {
                              this.$router.push({name: 'facilities.sections.view', params: {id:
                                  model.Facility_FK.id,
                                  sectionId: model.SectionParent_FK.id}})
                            }
                          },
                        ]
                      },
                      {
                        styleClasses:
                            'w-1/12 crud-buttons flex',
                        fields: [
                          {
                            type: 'awesomeButton',
                            styleClasses: 'awesome-form-button edit',
                            buttonOptions: {
                              route: {
                                name: 'facilities.sections.ancestors.edit',
                                routeParam: 'ancestorId',
                              },
                              icon: {
                                prefix: 'fal',
                                iconName: 'pencil'
                              },
                            },
                          },
                          {
                            type: 'awesomeButton',
                            styleClasses: 'awesome-form-button delete',
                            buttonOptions: {
                              icon: {
                                prefix: 'fal',
                                iconName: 'times'
                              },
                            },
                            onClick: async (model) => {
                              this.$emit(
                                  'deleteAncestor',
                                  model.id
                              )
                            }
                          }
                        ]
                      }
                    ]
                  }
                }
              },
            ]
          },
        ],
      },
      refs: [],
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true,
      },
      facilities: [],
      sections: [],
      options: [
        {
          endpoint: () => this.$api.facilities.list(),
          optionsFieldName: 'facilities',
          nameFieldName: 'FacilityReference',
          idFieldName: 'Facility_FK',
          modelArrayName: 'ancestors',
        },
      ],
    };
  },
  computed: {
    showForm() {
      return this.value.ancestors
          ? this.value.ancestors.length
          : false;
    },
    showRemoveButton() {
      return true; // FOR TESTING

      return this.componentAccess.canDelete.access;
    }
  },
  methods: {
    goToCreate() {
      this.$router.push({ name: 'facilities.sections.ancestors.create' })
    },

    /**
     * Load sections manually using Facility keys
     * @returns {Promise<void>}
     */
    async postOptions() {
      // Get all ID's of facilities being passed in
      let newIds = this.model.ancestors.map(({Facility_FK}) =>
          Facility_FK && Facility_FK.id ? Facility_FK.id : Facility_FK
      )
          .filter((id) => parseInt(id));

      // Unique
      newIds = [...new Set(newIds)];

      // Do we even need to do an API Call?
      if (newIds.length > 0 &&
          !this.sections.find(({Facility_FK}) => newIds.includes(Facility_FK))
      ) {
        await this.loadSections(newIds);
        await this.loadModelReferenceIntoObject('SectionParent_FK', 'sections', 'ancestors');
      }
    },
    async loadSections(facilityIds) {
      return new Promise(async (resolve) => {
        const sections = await Promise.all(facilityIds.flatMap(async ( id) => await this.getSectionOptions(id)));
        this.sections = sections.flatMap((i) => i);
        resolve();
      });
    },
    async getSectionOptions(Facility_FK) {
      const { data } = await this.$api.facilities.sections.list(Facility_FK);
      return data.data.map((i) => ({ id: i.id, name: i.Section, Facility_FK }));
    },
  },
};
</script>
